import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MessageNotification } from './message-notification';
import { getFilteredMessages } from './helpers';

export const ModalMessages = ({ forTypes, errorMessages, messages }) =>
  [...getFilteredMessages(forTypes, messages, errorMessages)].map((message) => (
    <MessageNotification key={message.id} message={message} />
  ));

export const mapStateToProps = ({
  messages: {
    modal: { errorMessages, messages },
  },
}) => ({
  errorMessages,
  messages,
});

export const ConnectedMessages = connect(mapStateToProps)(ModalMessages);

ModalMessages.propTypes = {
  forTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({})),
};
